/** Safe customer-facing failure for a configured command with no supported destination. */
export class CanonicalActionUnavailableError extends Error {}
